module.exports = __webpack_public_path__ + "img/30_ancillary.7ad1e56e.jpg";